import script from "./SpeakerDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeakerDetail.vue?vue&type=script&setup=true&lang=js"

import "./SpeakerDetail.vue?vue&type=style&index=0&id=c0809740&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0809740"]])

export default __exports__